var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "needGoodsForm" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            "custom-class": "form_drawer",
            title: _vm.drawerTitle,
            size: "80%",
            visible: _vm.formShow,
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.formShow = $event
            },
            closeDrawer: _vm.closeDrawer,
          },
        },
        [
          _c(
            "DrawerComponent",
            {
              attrs: {
                button: _vm.drawerButton,
                loading: _vm.loading,
                drawerConfig: _vm.drawerConfig,
              },
              on: {
                colse: function ($event) {
                  _vm.formShow = false
                },
                save: _vm.requestSave,
              },
            },
            [
              _c("div", { staticClass: "drawer-content-item" }, [
                _c("div", [
                  _vm.drawerConfig[0].ruleForm.orderType === "1"
                    ? _c(
                        "div",
                        {
                          staticClass: "slot-body",
                          staticStyle: { "justify-content": "flex-start" },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "label",
                                  staticStyle: { width: "auto" },
                                },
                                [_vm._v("是否使用经销商渠道奖励池抵扣:")]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: this.code === "view",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.changeUseChannelFee },
                                  model: {
                                    value:
                                      _vm.drawerConfig[0].ruleForm
                                        .newUseChannelFee,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.drawerConfig[0].ruleForm,
                                        "newUseChannelFee",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "drawerConfig[0].ruleForm.newUseChannelFee",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "否", value: "N" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "是", value: "Y" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.drawerConfig[0].ruleForm.newUseChannelFee === "Y"
                            ? _c(
                                "div",
                                { staticStyle: { "margin-left": "30px" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "label",
                                      staticStyle: { width: "auto" },
                                    },
                                    [_vm._v("可用费用奖励池金额（元）:")]
                                  ),
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value:
                                        _vm.drawerConfig[0].ruleForm
                                          .availableChannelFeeReward,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.drawerConfig[0].ruleForm,
                                          "availableChannelFeeReward",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "drawerConfig[0].ruleForm.availableChannelFeeReward",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "drawer-content-title" }, [
                    _vm._v("结算信息"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "slot-body",
                      staticStyle: { "flex-wrap": "wrap" },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("订单总金额（元）:"),
                          ]),
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.drawerConfig[0].ruleForm.amount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.drawerConfig[0].ruleForm,
                                  "amount",
                                  $$v
                                )
                              },
                              expression: "drawerConfig[0].ruleForm.amount",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("应付合计（元）:"),
                          ]),
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.drawerConfig[0].ruleForm.shouldPayAmount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.drawerConfig[0].ruleForm,
                                  "shouldPayAmount",
                                  $$v
                                )
                              },
                              expression:
                                "drawerConfig[0].ruleForm.shouldPayAmount",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("实际结算金额（元）:"),
                          ]),
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.drawerConfig[0].ruleForm.actualSettleAmount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.drawerConfig[0].ruleForm,
                                  "actualSettleAmount",
                                  $$v
                                )
                              },
                              expression:
                                "drawerConfig[0].ruleForm.actualSettleAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "drawer-content-title" }, [
                    _vm._v("结算方式"),
                  ]),
                  _c("div", { staticClass: "slot-body" }, [
                    _c(
                      "div",
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("B类资金账户实际支付（元）:"),
                        ]),
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.drawerConfig[0].ruleForm.actualAmount,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.drawerConfig[0].ruleForm,
                                "actualAmount",
                                $$v
                              )
                            },
                            expression: "drawerConfig[0].ruleForm.actualAmount",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm.drawerShowProduct
            ? _c(
                "div",
                [
                  _c(
                    "el-drawer",
                    {
                      attrs: {
                        "custom-class": "form_drawer",
                        title: "添加商品",
                        size: "80%",
                        visible: _vm.drawerShowProduct,
                        modal: false,
                        "append-to-body": true,
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.drawerShowProduct = $event
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "drawer-table" },
                        [
                          _c("TableComponent", {
                            attrs: {
                              templateData: _vm.tableDataProduct,
                              pagination: _vm.tablePaginationProduct,
                              "table-loading": _vm.tableLoadingProduct,
                              searchConfig: _vm.searchConfigProduct,
                              "table-config": _vm.tableConfigProduct,
                            },
                            on: { searchData: _vm.selectSearchProduct },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "drawer-button" },
                        [
                          _c(
                            "buttonComponent",
                            {
                              attrs: {
                                btnType: "primary",
                                icon: "el-icon-check",
                              },
                              on: { clickEvent: _vm.beforeSaveSelect },
                            },
                            [_vm._v("保存 ")]
                          ),
                          _c(
                            "buttonComponent",
                            {
                              attrs: {
                                btnType: "danger",
                                icon: "el-icon-close",
                              },
                              on: {
                                clickEvent: function ($event) {
                                  _vm.drawerShowProduct = false
                                },
                              },
                            },
                            [_vm._v("关闭 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c(
                "el-drawer",
                {
                  attrs: {
                    "custom-class": "form_drawer",
                    title: "选择客户",
                    size: "80%",
                    visible: _vm.drawerShowCustomer,
                    modal: false,
                    "append-to-body": true,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.drawerShowCustomer = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "drawer-table" },
                    [
                      _c("TableComponent", {
                        attrs: {
                          templateData: _vm.tableDataCustomer,
                          "table-loading": _vm.tableLoadingCustomer,
                          searchConfig: _vm.searchConfigCustomer,
                          "table-config": _vm.tableConfigCustomer,
                        },
                        on: { searchData: _vm.searchCustomer },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "drawer-button" },
                    [
                      _c(
                        "buttonComponent",
                        {
                          attrs: { btnType: "primary", icon: "el-icon-check" },
                          on: { clickEvent: _vm.beforeSaveSelect },
                        },
                        [_vm._v("保存 ")]
                      ),
                      _c(
                        "buttonComponent",
                        {
                          attrs: { btnType: "danger", icon: "el-icon-close" },
                          on: {
                            clickEvent: function ($event) {
                              _vm.drawerShowCustomer = false
                            },
                          },
                        },
                        [_vm._v("关闭 ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-drawer",
                {
                  attrs: {
                    "custom-class": "form_drawer",
                    title: "选择关联活动",
                    size: "80%",
                    visible: _vm.drawerShowAct,
                    modal: false,
                    "append-to-body": true,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.drawerShowAct = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "drawer-table" },
                    [
                      _c("TableComponent", {
                        attrs: {
                          templateData: _vm.tableDataAct,
                          "table-loading": _vm.tableLoadingAct,
                          searchConfig: _vm.searchConfigAct,
                          "table-config": _vm.tableConfigAct,
                          pagination: _vm.paginationAct,
                        },
                        on: { searchData: _vm.searchAct },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "drawer-button" },
                    [
                      _c(
                        "buttonComponent",
                        {
                          attrs: { btnType: "primary", icon: "el-icon-check" },
                          on: { clickEvent: _vm.beforeSaveSelect },
                        },
                        [_vm._v("保存 ")]
                      ),
                      _c(
                        "buttonComponent",
                        {
                          attrs: { btnType: "danger", icon: "el-icon-close" },
                          on: {
                            clickEvent: function ($event) {
                              _vm.drawerShowAct = false
                            },
                          },
                        },
                        [_vm._v("关闭 ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-drawer",
                {
                  attrs: {
                    "custom-class": "form_drawer",
                    title: "选择负责人",
                    size: "80%",
                    visible: _vm.drawerShowResponese,
                    modal: false,
                    "append-to-body": true,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.drawerShowResponese = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "drawer-table" },
                    [
                      _c("TableComponent", {
                        attrs: {
                          templateData: _vm.tableDataResponese,
                          "table-loading": _vm.tableLoadingResponese,
                          searchConfig: _vm.searchConfigResponese,
                          "table-config": _vm.tableConfigResponese,
                          pagination: _vm.pagination,
                        },
                        on: { searchData: _vm.searchResponeseAll },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "drawer-button" },
                    [
                      _c(
                        "buttonComponent",
                        {
                          attrs: { btnType: "primary", icon: "el-icon-check" },
                          on: { clickEvent: _vm.beforeSaveSelect },
                        },
                        [_vm._v("保存 ")]
                      ),
                      _c(
                        "buttonComponent",
                        {
                          attrs: { btnType: "danger", icon: "el-icon-close" },
                          on: {
                            clickEvent: function ($event) {
                              _vm.drawerShowResponese = false
                            },
                          },
                        },
                        [_vm._v("关闭 ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-drawer",
                {
                  attrs: {
                    "custom-class": "form_drawer",
                    title: "选择开票人",
                    size: "80%",
                    visible: _vm.drawerShowTicket,
                    modal: false,
                    "append-to-body": true,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.drawerShowTicket = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "drawer-table" },
                    [
                      _c("TableComponent", {
                        attrs: {
                          templateData: _vm.tableDataTicket,
                          "table-loading": _vm.tableLoadingTicket,
                          searchConfig: _vm.searchConfigTicket,
                          "table-config": _vm.tableConfigTicket,
                        },
                        on: { searchData: _vm.searchTicket },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "drawer-button" },
                    [
                      _c(
                        "buttonComponent",
                        {
                          attrs: { btnType: "primary", icon: "el-icon-check" },
                          on: { clickEvent: _vm.beforeSaveSelect },
                        },
                        [_vm._v("保存 ")]
                      ),
                      _c(
                        "buttonComponent",
                        {
                          attrs: { btnType: "danger", icon: "el-icon-close" },
                          on: {
                            clickEvent: function ($event) {
                              _vm.drawerShowTicket = false
                            },
                          },
                        },
                        [_vm._v("关闭 ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm.isCart
            ? _c(
                "div",
                {
                  staticStyle: { "text-align": "right", padding: "20px" },
                  attrs: { loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.carReport()
                    },
                  },
                },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v(" 报车 "),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.dmsId
        ? _c(
            "DrawerComponent",
            {
              attrs: {
                button: _vm.drawerButton,
                loading: _vm.loading,
                drawerConfig: _vm.drawerConfig,
              },
              on: {
                colse: function ($event) {
                  _vm.formShow = false
                },
                save: _vm.requestSave,
              },
            },
            [
              _c("div", { staticClass: "drawer-content-item" }, [
                _c("div", [
                  _vm.drawerConfig[0].ruleForm.orderType === "1"
                    ? _c(
                        "div",
                        {
                          staticClass: "slot-body",
                          staticStyle: { "justify-content": "flex-start" },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "label",
                                  staticStyle: { width: "auto" },
                                },
                                [_vm._v("是否使用经销商渠道奖励池抵扣:")]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: true,
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.changeUseChannelFee },
                                  model: {
                                    value:
                                      _vm.drawerConfig[0].ruleForm
                                        .newUseChannelFee,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.drawerConfig[0].ruleForm,
                                        "newUseChannelFee",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "drawerConfig[0].ruleForm.newUseChannelFee",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "否", value: "N" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "是", value: "Y" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.drawerConfig[0].ruleForm.newUseChannelFee === "Y"
                            ? _c(
                                "div",
                                { staticStyle: { "margin-left": "30px" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "label",
                                      staticStyle: { width: "auto" },
                                    },
                                    [_vm._v("可用费用奖励池金额（元）:")]
                                  ),
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value:
                                        _vm.drawerConfig[0].ruleForm
                                          .availableChannelFeeReward,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.drawerConfig[0].ruleForm,
                                          "availableChannelFeeReward",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "drawerConfig[0].ruleForm.availableChannelFeeReward",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "drawer-content-title" }, [
                    _vm._v("结算信息"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "slot-body",
                      staticStyle: { "flex-wrap": "wrap" },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("订单总金额（元）:"),
                          ]),
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.drawerConfig[0].ruleForm.amount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.drawerConfig[0].ruleForm,
                                  "amount",
                                  $$v
                                )
                              },
                              expression: "drawerConfig[0].ruleForm.amount",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("应付合计（元）:"),
                          ]),
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.drawerConfig[0].ruleForm.shouldPayAmount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.drawerConfig[0].ruleForm,
                                  "shouldPayAmount",
                                  $$v
                                )
                              },
                              expression:
                                "drawerConfig[0].ruleForm.shouldPayAmount",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("实际结算金额（元）:"),
                          ]),
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.drawerConfig[0].ruleForm.actualSettleAmount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.drawerConfig[0].ruleForm,
                                  "actualSettleAmount",
                                  $$v
                                )
                              },
                              expression:
                                "drawerConfig[0].ruleForm.actualSettleAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "drawer-content-title" }, [
                    _vm._v("结算方式"),
                  ]),
                  _c("div", { staticClass: "slot-body" }, [
                    _vm.drawerConfig[0].ruleForm.businessType === "B"
                      ? _c(
                          "div",
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("B类资金余额（元）:"),
                            ]),
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.drawerConfig[0].ruleForm.balance,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.drawerConfig[0].ruleForm,
                                    "balance",
                                    $$v
                                  )
                                },
                                expression: "drawerConfig[0].ruleForm.balance",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.drawerConfig[0].ruleForm.businessType === "B"
                      ? _c(
                          "div",
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("B类费用支付（元）:"),
                            ]),
                            _c("el-input", {
                              attrs: { disabled: "" },
                              on: {
                                input: function ($event) {
                                  return _vm.calculateCaptital(
                                    "bcaptitalAmount"
                                  )
                                },
                              },
                              model: {
                                value:
                                  _vm.drawerConfig[0].ruleForm.bcaptitalAmount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.drawerConfig[0].ruleForm,
                                    "bcaptitalAmount",
                                    $$v
                                  )
                                },
                                expression:
                                  "drawerConfig[0].ruleForm.bcaptitalAmount",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.drawerConfig[0].ruleForm.orderType === "4"
                      ? _c(
                          "div",
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("货补资金余额:"),
                            ]),
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.drawerConfig[0].ruleForm.balance,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.drawerConfig[0].ruleForm,
                                    "balance",
                                    $$v
                                  )
                                },
                                expression: "drawerConfig[0].ruleForm.balance",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.drawerConfig[0].ruleForm.orderType === "4"
                      ? _c(
                          "div",
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("货补资金支付（元）:"),
                            ]),
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.drawerConfig[0].ruleForm.captitalAmount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.drawerConfig[0].ruleForm,
                                    "captitalAmount",
                                    $$v
                                  )
                                },
                                expression:
                                  "drawerConfig[0].ruleForm.captitalAmount",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("B类资金账户实际支付（元）:"),
                        ]),
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.drawerConfig[0].ruleForm.actualAmount,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.drawerConfig[0].ruleForm,
                                "actualAmount",
                                $$v
                              )
                            },
                            expression: "drawerConfig[0].ruleForm.actualAmount",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }